import React, { memo } from 'react';
import { useHistory, useLocation } from 'react-router';

import ConnectToCalModal from 'Shared/components/modals/SyncCalendarFlowModals/ConnectToCalModal/ConnectToCalModal';

function SyncMeetingsModalHandler() {
  const history = useHistory();
  const { pathname, search } = useLocation();

  const showSyncMeetingsModal = search.includes('set_recurring_meetings');

  const handleSyncMeetingsModalClose = ({ redirectPath = null } = {}) => history.push(redirectPath || pathname);

  return showSyncMeetingsModal ? <ConnectToCalModal onToggle={handleSyncMeetingsModalClose} /> : null;
}

export default memo(SyncMeetingsModalHandler);
